import { Bets } from '../../../config/bets';
import { useGameSelector } from '../../GameStore';

import { HighflyerStateSliceProps } from './slice';
import type { winStates } from './types';

export const useHighflyerStateSlice = {
  getGameResult: (): HighflyerStateSliceProps['gameResult'] => {
    return useGameSelector(({ highflyerState }) => highflyerState.gameResult);
  },
  getWaitForWinResult: (): boolean => {
    return useGameSelector(({ highflyerState }) => highflyerState.waitForWinResult);
  },
  getMultiplier: (): any => {
    return useGameSelector(({ highflyerState }) => highflyerState.multiplier);
  },
  hasEarlyBets: (betCode: Bets): boolean => {
    return useGameSelector(({ highflyerState }) => highflyerState.earlyBetAmount[betCode] > 0);
  },
  hasAnyEarlyBets: (): boolean => {
    return useGameSelector(({ highflyerState }) => {
      return highflyerState.earlyBetAmount[Bets.ONE] > 0 || highflyerState.earlyBetAmount[Bets.TWO] > 0;
    });
  },
  getCashedAmount: (betId: Bets): number => {
    return useGameSelector(({ highflyerState }) => highflyerState.cashedAmounts[betId]);
  },
  getWinState: (): winStates => {
    return useGameSelector(({ highflyerState }) => highflyerState.winState);
  },
  isDealingInProgress: (betCode: Bets): boolean => {
    return useGameSelector(({ highflyerState }) => highflyerState.isDealingInProgress[betCode]);
  },
  isFullCashed: (): boolean => {
    return useGameSelector(
      ({ highflyerState }) =>
        !highflyerState.isDealingInProgress[Bets.ONE] && !highflyerState.isDealingInProgress[Bets.TWO]
    );
  },
  isLocalCashed: (betId: Bets): boolean => {
    return useGameSelector(({ highflyerState }) => highflyerState.localCashedMul[betId] > 0);
  },
  getLocalCashedMul: (betId: Bets): number => {
    return useGameSelector(({ highflyerState }) => highflyerState.localCashedMul[betId]);
  },
  getCashedObj: (): Record<string, number> => {
    return useGameSelector(({ highflyerState }) => highflyerState.cashedAmounts);
  },
  getEarlyBetAmount: (betCode: Bets): number => {
    return useGameSelector(({ highflyerState }) => highflyerState.earlyBetAmount[betCode]);
  },
  getTotalEarlyBetAmount: (): number => {
    return useGameSelector(({ highflyerState }) => {
      return highflyerState.earlyBetAmount[Bets.ONE] + highflyerState.earlyBetAmount[Bets.TWO];
    });
  },
  balance: (): number => {
    return useGameSelector(({ highflyerState }) => highflyerState.balance);
  },
  isSingleBetPlaced: (): boolean => {
    return useGameSelector(({ highflyerState }) => highflyerState.isSingleBetPlaced);
  },
  isBetPlaced: (betId: Bets): boolean => {
    return useGameSelector(({ highflyerState }) => highflyerState.isBetPlaced[betId]);
  },
};
